// Basic traversable n-ary tree

export class TreeNode implements TreeNodeInterface {
  public parent: TreeNodeInterface | null;
  public children: TreeNodeInterface[] = [];
  constructor(parent: TreeNodeInterface | null) {
    this.parent = parent;
    if (this.parent) {
      this.parent.children.push(this);
    }
  }
}

export interface TreeNodeInterface {
  parent: TreeNodeInterface | null;
  children: TreeNodeInterface[];
}
